import React from 'react'
import PropTypes from 'prop-types'
import { Redirect, Switch as RouterSwitch, withRouter } from 'react-router-dom'
import PrivateRoute from '../../hocs/PrivateRoute'
import OpportunitiesPage from './OpportunitiesPage'
import PlacesPage from './PlacesPage'
import ReviewDetail from './ReviewDetail'
import ReviewsPage from './ReviewsPage'
import RunsPage from './RunsPage'
import SettingsPage from './SettingsPage'

// The growth bot's pages (spec: 0042_growth_bot): what it found, where the owner can travel, what
// last week looked like, what it did and cost, and its setup.
const GrowthRoutes = ({ match }) => (
  <RouterSwitch>
    <Redirect exact from={match.path} to={`${match.path}/opportunities`} />
    <PrivateRoute exact path={`${match.path}/opportunities`} component={OpportunitiesPage} />
    <PrivateRoute exact path={`${match.path}/places`} component={PlacesPage} />
    <PrivateRoute exact path={`${match.path}/reviews`} component={ReviewsPage} />
    <PrivateRoute exact path={`${match.path}/reviews/:id`} component={ReviewDetail} />
    <PrivateRoute exact path={`${match.path}/runs`} component={RunsPage} />
    <PrivateRoute exact path={`${match.path}/settings`} component={SettingsPage} />
  </RouterSwitch>
)

GrowthRoutes.propTypes = { match: PropTypes.object }

export default withRouter(GrowthRoutes)
